export enum WorkflowTriggerTypes {
    /// <summary>
    /// Clic sur un bouton de l'application.
    /// </summary>
    ButtonClic = 1,
    /// <summary>
    /// Un attribut a été modifié.
    /// </summary>
    AttributeChanged = 2,
    /// <summary>
    /// Un mail a été envoyé.
    /// </summary>
    EmailSent = 3,
    /// <summary>
    /// Un SMS a été envoyé.
    /// </summary>
    SmsSent = 4,
    /// <summary>
    /// Une date a été atteinte.
    /// </summary>
    DateReached = 5,
    /// <summary>
    /// Un délai a expiré.
    /// </summary>
    DelayExpired = 6,
    /// <summary>
    /// Un mail a été reçu.
    /// </summary>
    MailReceived = 7,
    /// <summary>
    /// Un SMS a été reçu.
    /// </summary>
    SmsReceived = 8,
    /// <summary>
    /// L'état d'une étape a été modifié.
    /// </summary>
    StepStateChanged = 9,
    /// <summary>
    /// L'étape courante du workflow a changée.
    /// </summary>
    StepActivated = 10,
    /// <summary>
    /// Une étape a été terminée.
    /// </summary>
    StepCompleted = 11,
    /// <summary>
    /// Un dossier a été créé.
    /// </summary>
    FolderCreated = 12,
    /// <summary>
    /// Un minuteur s'est déclenché.
    /// </summary>
    Timer = 13,
}
